import { axios } from "@app/app/services/axios";
import { UtilsUrl } from "@hotelchamp/common";

import { PaymentTypes } from "./constants/PaymentTypes";
import { IPaymentIntent, IPaymentSetupIntent, TPaymentIntentModel } from "./types";

export interface IGetPaymentIntentOptions {
    doSync?: boolean;
}
export const getPaymentIntent = async (paymentIntentId: string, options: IGetPaymentIntentOptions = {}): Promise<IPaymentIntent> => {
    const response = await axios.get(`payment_intents/${paymentIntentId}?${UtilsUrl.stringifySearchParams(options)}`);

    return response.data;
};

export interface IGetPaymentSetupIntentOptions extends IGetPaymentIntentOptions {}
export const getPaymentSetupIntent = async (
    paymentSetupIntentId: string,
    options: IGetPaymentIntentOptions = {}
): Promise<IPaymentSetupIntent> => {
    const response = await axios.get(`payment_setup_intents/${paymentSetupIntentId}?${UtilsUrl.stringifySearchParams(options)}`);

    return response.data;
};

/**
 * Abstracts the logic of getting the payment intent model based on the payment type.
 * @param paymentType
 * @param paymentIntentModelId
 * @param options
 * @returns
 */
export const getPaymentIntentModel = async (
    paymentType?: PaymentTypes,
    paymentIntentModelId?: string,
    options: IGetPaymentIntentOptions = {}
): Promise<TPaymentIntentModel> => {
    if (paymentType === PaymentTypes.Direct) {
        return getPaymentIntent(paymentIntentModelId || "", options);
    }

    return getPaymentSetupIntent(paymentIntentModelId || "", options);
};

export const cancelPaymentIntent = async (paymentIntentId: string): Promise<void> => {
    const response = await axios.delete(`payment_intents/${paymentIntentId}`);

    return response.data;
};

export const cancelPaymentSetupIntent = async (paymentSetupIntentId: string): Promise<void> => {
    const response = await axios.delete(`payment_setup_intents/${paymentSetupIntentId}`);

    return response.data;
};

/**
 * Abstracts the logic of cancelling the payment intent model based on the payment type.
 * @param paymentType
 * @param paymentIntentModelId
 * @param options
 * @returns
 */
export const cancelPaymentIntentModel = async ({
    paymentType,
    paymentIntentModelId,
}: {
    paymentType: PaymentTypes;
    paymentIntentModelId: string;
}): Promise<void> => {
    if (paymentType === PaymentTypes.Direct) {
        return cancelPaymentIntent(paymentIntentModelId || "");
    }

    return cancelPaymentSetupIntent(paymentIntentModelId || "");
};
